const _doctorId = Symbol();
const _targetFlexion = Symbol();
const _targetExtension = Symbol();
const _sessionsPerDay = Symbol();
const _sessionDuration = Symbol();

const coalesce = (...args) => {
	return args.find(arg => arg !== undefined);
};

const intToDaily = v => {
	if(!Number.isInteger(v))
		throw new TypeError('value must be an integer.');
	switch(v) {
		case 1: return 'once a day';
		case 2: return 'twice a day';
		default: return `${v} times a day`;
	}
};

export class DoctorKneeProtocol {
	constructor(doctorId, targetFlexion, targetExtension, sessionsPerDay, sessionDuration) {
		this.doctorId = doctorId;
		this.targetFlexion = targetFlexion;
		this.targetExtension = targetExtension;
		this.sessionsPerDay = sessionsPerDay;
		this.sessionDuration = sessionDuration;
	}
	get doctorId() {
		return this[_doctorId];
	}
	set doctorId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('doctorId must be an integer.');
		this[_doctorId] = v;
	}
	get targetFlexion() {
		return this[_targetFlexion];
	}
	set targetFlexion(v) {
		if(!Number.isInteger(v))
			throw new TypeError('targetFlexion must be an integer.');
		this[_targetFlexion] = v;
	}
	get targetExtension() {
		return this[_targetExtension];
	}
	set targetExtension(v) {
		if(!Number.isInteger(v))
			throw new TypeError('targetExtension must be an integer.');
		this[_targetExtension] = v;
	}
	get sessionsPerDay() {
		return this[_sessionsPerDay];
	}
	set sessionsPerDay(v) {
		if(!Number.isInteger(v))
			throw new TypeError('sessionsPerDay must be an integer.');
		this[_sessionsPerDay] = v;
	}
	get sessionDuration() {
		return this[_sessionDuration];
	}
	set sessionDuration(v) {
		if(!Number.isInteger(v))
			throw new TypeError('sessionDuration must be an integer.');
		this[_sessionDuration] = v;
	}
	get durationText() {
		return `${this.sessionDuration} minutes, ${intToDaily(this.sessionsPerDay)}`;
	}
	toJSON() {
		return {
			doctorId: this.doctorId,
			targetFlexion: this.targetFlexion,
			targetExtension: this.targetExtension,
			sessionsPerDay: this.sessionsPerDay,
			sessionDuration: this.sessionDuration
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.doctorId, obj.DoctorId, null),
			coalesce(obj.targetFlexion, obj.TargetFlexion, null),
			coalesce(obj.targetExtension, obj.TargetExtension, null),
			coalesce(obj.sessionsPerDay, obj.SessionsPerDay, null),
			coalesce(obj.sessionDuration, obj.SessionDuration, null)
		);
	}
}